import { Group, Stack } from '@mantine/core';
import * as Sentry from '@sentry/browser';
import { useNavigate } from 'react-router';
import { DEFAULT_ROUTE } from '../../../../constants';
import { redirectToBackendOAuthNext } from '../../../../helpers/general-helpers';
import { resetAuthStore } from '../../../../store/auth-store/auth-store.actions';
import { useGlobalStore } from '../../../../store/global-store/global-store';
import { setOrganization, setPortfolio } from '../../../../store/global-store/global-store.actions';
import { Icon } from '../../../../ui-library/icon/icon';
import { H3 } from '../../../../ui-library/typography/typography';
import { Layout } from '../../layout';
import { OrganizationList } from './select-organization-list';

export const SelectOrganization = () => {
  const navigate = useNavigate();

  const organizations = useGlobalStore((state) => state.organizations);
  const portfolios = useGlobalStore((state) => state.portfolios);
  const currentPortfolio = useGlobalStore((state) => state.portfolio);

  const handleSelect = (organizationId: string) => {
    try {
      // Use cached portfolio if it belongs to the selected organization,
      // otherwise find the default portfolio (is_default: true) or fall back to any portfolio
      const organizationPortfolios = portfolios.filter((portfolio) => portfolio.organization.id === organizationId);
      const defaultPortfolio =
        (currentPortfolio?.organization.id === organizationId ? currentPortfolio : null) ||
        organizationPortfolios.find((portfolio) => portfolio.is_default) ||
        organizationPortfolios[0] ||
        null;

      setOrganization(organizations?.find((o) => o.id === organizationId) || null);
      setPortfolio(defaultPortfolio);
      resetAuthStore();

      // A multi-org user who reached the picker via the MCP OAuth flow still
      // carries `oauth_next` in the URL (org selection does not navigate). Now
      // that onboarding is complete, finish the origin-locked backend redirect
      // instead of dropping them on the dashboard and hanging the MCP client.
      if (redirectToBackendOAuthNext()) {
        return;
      }

      navigate(DEFAULT_ROUTE);
    } catch (error) {
      Sentry.captureException(error);
    }
  };

  return (
    <Layout>
      <Stack gap={32}>
        <Group gap={16}>
          <Icon name="home_work" size={32} />
          <H3>Select Organization</H3>
        </Group>
        <OrganizationList organizations={organizations} onSelect={handleSelect} />
      </Stack>
    </Layout>
  );
};
